import ContactModel from "../Models/Authentication/ContactModel";
import ApiCalls from "./ApiCalls";

export default class ContactService {
  public async upsertContact(model: ContactModel): Promise<boolean> {
    let baseUrl = process.env.REACT_APP_API_URL;
    let url = baseUrl + `/api/contact/upsert`;

    let apiCalls = new ApiCalls();
    let result = await apiCalls.Post(url, model);
    return result;
  }
}
